import './cluster.css'
import './web_component'
import React from 'react'
import { ClusterLayoutProps } from './types'

export const Cluster: React.FC<ClusterLayoutProps> = ({ children, ...props }) => (
  <cluster-l {...props}>{children}</cluster-l>
)
